var render = function render(){var _vm=this,_c=_vm._self._c;return _c('VbDemo',[_c('VbCard',{attrs:{"dashed":"","no-padding":""}},[_c('Signup',{staticStyle:{"width":"500px"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }